import { useEffect, useState } from 'react';
import t from 'react-translate';
import Badge from 'react-bootstrap/esm/Badge';

export enum CardBadge {
  REGISTERED = 'registered',
  ATTENDED = 'attended',
  VIEWED = 'viewed',
  UNREGISTERED = 'unregistered',
  PENDING = 'pending',
  MISSED = 'missed',
}

const liveSessionCardBadgeSettings = {
  [CardBadge.REGISTERED]: {
    className: 'bg-gray-2',
    translationKey: 'REGISTERED',
  },
  [CardBadge.ATTENDED]: {
    className: 'bg-success',
    translationKey: 'ATTENDED',
  },
  [CardBadge.VIEWED]: {
    className: 'bg-primary',
    translationKey: 'VIEWED',
  },
  [CardBadge.PENDING]: {
    className: 'bg-gray-3',
    translationKey: 'PENDING',
  },
  [CardBadge.MISSED]: {
    className: 'bg-gray-3',
    translationKey: 'MISSED',
  },
};

type LiveSessionCardTitleProps = {
  title: string
  status: CardBadge
  allowUserRegistration: boolean
};

const LiveSessionCardTitle = (props: LiveSessionCardTitleProps) => {
  const {
    title,
    status,
    allowUserRegistration,
  } = props;

  const { translationKey, className } = status && status !== CardBadge.UNREGISTERED
    ? liveSessionCardBadgeSettings[status]
    : { className: '', translationKey: '' };
  const translationPrefix = t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.SESSION_CARD.BADGE;
  const text = translationKey ? translationPrefix[translationKey]?.() ?? '' : '';
  /**
   * If user registration enabled: The badge will be shown to all cases except if the user is unergistered
   * If the registration disabled: The badge will not show for 'registered, not registered and registered(missed)
   */
  const showStatusBadge = text && (allowUserRegistration
    ? status !== CardBadge.UNREGISTERED
    : ![CardBadge.UNREGISTERED, CardBadge.REGISTERED, CardBadge.MISSED].includes(status));

  return (
    <div className='session-title d-flex flex-column'>
      <div className='text-large-body bold mr-2'>{title}</div>
      {showStatusBadge && (
        <div>
          <Badge css={{ borderRadius: '5px' }} className={`${className} text-small bold mt-1`}>{text}</Badge>
        </div>
      )}
    </div>
  );
};

export default LiveSessionCardTitle;
